import axios from 'axios'
import CreateGraduated from './dto/CreateGraduated'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedGraduatedResultRequestDto} from './dto/PagedGraduatedResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllGraduates from './dto/GetAllGraduates'
import UpdateGraduated from './dto/UpdateGraduated'
import GetGraduated from './dto/GetGraduated'
import CreateUserForGraduatedInput from './dto/CreateUserForGraduatedInput'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Graduated/Create`
export const URL_DELETE = `${API_URL}/Graduated/Delete`
export const URL_GET = `${API_URL}/Graduated/Get`
export const URL_GET_MY_INFO = `${API_URL}/Graduated/GetMyInfo`
export const URL_GET_ALL = `${API_URL}/Graduated/GetPagedAll`
export const URL_UPDATE = `${API_URL}/Graduated/Update`
export const URL_GET_BY_USER_ID = `${API_URL}/Graduated/GetByUserId`
export const URL_CREATEUSERFORGRADUATED = `${API_URL}/User/UpdateForGraduate`

export function onCreateGraduated(createGraduated: CreateGraduated): Promise<boolean> {
  return axios.post(URL_CREATE, createGraduated)
}

export function onDeleteGraduated(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetGraduatesByUserId(user: EntityDto): Promise<GetGraduated> {
  return axios.get(URL_GET_BY_USER_ID, {params: user})
}

export function onGetGraduated(entityDto: EntityDto): Promise<GetGraduated> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetMyGraduatedInfo(): Promise<GetGraduated> {
  return axios.get(URL_GET_MY_INFO)
}

export function onGetPagedAllGraduates(
  pagedFilterAndSortedRequest: PagedGraduatedResultRequestDto
): Promise<PagedResultDto<GetAllGraduates>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateGraduated(updateGraduatedInput: UpdateGraduated): Promise<boolean> {
  return axios.put(URL_UPDATE, updateGraduatedInput)
}

export function onCreateUserForGraduated(createUserForGraduatedInput: CreateUserForGraduatedInput): Promise<boolean> {
  return axios.put(URL_CREATEUSERFORGRADUATED, createUserForGraduatedInput)
}
